var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('div',{staticClass:"message-header"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n    "),_c('button',{staticClass:"delete",on:{"click":_vm.clicked}})]),_c('div',{staticClass:"message-body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }